import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import VCalendar from 'v-calendar'

import 'v-calendar/dist/style.css'
import { VueTelInputPlugin } from "vue3-tel-input";
import "vue3-tel-input/dist/vue3-tel-input.css";


const app = createApp(App)


// ✅ Use your plugins
app
  .use(store)
  .use(router)
  .use(VCalendar, {})
  .use(VueTelInputPlugin)
  .use(Toast, {
    transition: 'Vue-Toastification__bounce',
    maxToasts: 5,
    newestOnTop: true,
    position: 'top-right',
    timeout: 3000
  })

// ✅ Mount the app last
app.mount('#app')
